<template>
  <div class='portSettle'>
    <div class='tabs' v-if='!flag'>
      <div @click='typeFun(0)' class='left' :class='{ active: planType === 0 }'>操作费</div>
      <div @click='typeFun(1)' class="center" :class='{ active: planType === 1 }'>燃油费</div>
      <div @click='typeFun(2)' class="center" :class='{ active: planType === 2 }'>堆存费</div>
      <div @click='typeFun(3)'  :class='{ active: planType === 3 }'>过驳费（资源车）</div>
      <div @click='typeFun(25)' class='right' :class='{ active: planType === 25 }'>操作费补结算对账单</div>
    </div>
    <div class='tabs' v-else>
      <div @click='typeFun(0)' style='border-radius: 10px' :class='{ active: planType === 0 }'>操作费
      </div>
    </div>
    <div class='componentsContainer'>
      <operation v-if='planType === 0' ref='operation' />
      <electrify v-if='planType === 1' ref='electrify' />
      <stockpile v-if='planType === 2' ref='stockpile' />
      <refute-resources-car v-if='planType === 3' ref='refuteResourcesCar' />
      <!-- 操作费补结算对账单 -->
      <operation-reimbursement-statement v-if="planType === 25"/>
    </div>
  </div>
</template>

<script>
  import operation from '@/views/settle/supplierStatement/components/operation.vue';
  import electrify from '@/views/settle/supplierStatement/components/electrify.vue';
  import stockpile from '@/views/settle/supplierStatement/components/stockpile.vue';
  import RefuteResourcesCar from '@/views/settle/supplierStatement/components/refuteResourcesCar.vue';
  import { getSessionStore } from '@/config/mUtils';
  import OperationReimbursementStatement
    from "@/views/settle/supplierStatement/components/operationReimbursementStatement.vue";

  export default {
    components: {
      OperationReimbursementStatement,
      RefuteResourcesCar,
      operation,
      electrify,
      stockpile,
    },

    data() {
      return {
        planType: 0,
        flag: false,
      };
    },
    mounted() {
      this.getPermissions();
    },
    methods: {
      getPermissions() {
        if (getSessionStore('userDept') !== '[]') {
          this.flag = JSON.parse(getSessionStore('userDept'))[0].id === 'da7cfb6cbfe64425bc6e50f16ad64b58' || false;
        }
      },
      typeFun(val) {
        this.planType = val;
        this.$nextTick(() => {
          switch (val) {
            case 0:
             // this.$refs.operation.accountList();
              break;
            case 1:
             // this.$refs.electrify.accountList();
              break;
            case 2:
            //  this.$refs.stockpile.accountList();
              break;
          }
        });
      },
    },
  };
</script>


<style lang='scss' scoped>
  .portSettle {
    width: 100%;
    padding: 20px 15px 0 25px;
    display: flex;
    flex-direction: column;

    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 480px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599E;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599E;
        font-weight: 700;
        transition: all .3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        width: 90px;
      }
      .center{
        width: 90px;
      }

      .right {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        width: 150px;
      }

      .active {
        background: #48599E;
        color: #fff;
      }
    }

    .componentsContainer {
      width: 100%;
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
      }
    }
  }
</style>
